import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import "./Community.css";

const Community = () => {
  let { id } = useParams();
  const [communityMembers, setCommunityMembers] = useState([]);
  const [contentLoaded, setContentLoaded] = useState(false);

  useEffect(() => {
    if (id !== undefined) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "profile/getUserCommunityMembers", { id })
        .then((res) => {
          if (res.data.responseData) {
            setCommunityMembers(res.data.responseData);
            setContentLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleMemberData = (member) => {
    let fullName = `${member.first_name} ${member.last_name}`;

    let phoneNumber = member.phone_number;

    let email = member.email;
    return (
      <div key={member.id} className="community_card_single_hold">
        <div className="patient_detail_title">Support Team</div>
        <div className="community_detail_value community_person_img community_icon_position">{fullName}</div>
        <div className="community_detail_value community_phone_img community_icon_position">{phoneNumber}</div>
        <div className="community_detail_value community_email_img community_icon_position">{email}</div>
      </div>
    );
  };
  return !contentLoaded ? (
    <div className="loader_full_container">
      <div className="p_load"></div>
    </div>
  ) : (
    <div style={{flex: 1}} className="patient_list_container community_container">
      {communityMembers.length > 0 ? (
        <>
          <div className="patient_card_title">Support Team</div>
          <div className="community_cards_hold">{communityMembers.map((member) => handleMemberData(member))}</div>
        </>
      ) : (
        <div className="patient_card_title" style={{ textAlign: "center" }}>
          No Support Team
        </div>
      )}
    </div>
  );
};

export default Community;
